import { Autocomplete, TextField } from '@mui/material';
import { Account } from '../../../types';

interface AccountSelectorProps {
  disabled: boolean;
  options: Account[];
  value: Account | null;
  missing: boolean;
  onChange: (event: React.SyntheticEvent<Element, Event>, value: Account | null) => void;
}

/** The account a multi-account customer files the request under, with a prompt while none is picked. */
export function AccountSelector({ disabled, options, value, missing, onChange }: AccountSelectorProps) {
  return (
    <div className="w-full pt-5">
      <div
        className="text-gray-700"
        style={{ marginBottom: '0.5rem' }}>
        Account
      </div>
      <Autocomplete
        disabled={disabled}
        sx={{ width: '100%' }}
        size="small"
        options={options}
        value={value}
        onChange={onChange}
        isOptionEqualToValue={(option, selected) => option.id === selected.id}
        getOptionLabel={(option: Account) => option?.name ?? ''}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Account"
            data-cy="account-selector"
            error={missing}
            helperText={missing ? 'Please select an account' : undefined}
            inputProps={{
              ...params.inputProps,
              'aria-label': 'account',
              required: missing
            }}
          />
        )}
      />
    </div>
  );
}
